/*
 * Cinema Cellar - RPS locale links
 *
 * RPS renders product card links as bare "/products/<handle>", which drops the
 * locale prefix (e.g. "/fr/") and sends French shoppers to the English PDP.
 * Rewrites those hrefs to use Shopify.routes.root. No-op on the default locale.
 */
(function () {
  'use strict';

  var PATH_RE = /^\/(products|collections)\//;
  var LINK_SELECTOR = 'a[href*="/products/"], a[href*="/collections/"]';

  // Returns the localized href, or null when the href should be left alone
  // (external, already prefixed, or not a product/collection link).
  function localizeHref(href, root, host) {
    if (!href || !root || root === '/') return null;

    var path = href;
    if (/^https?:\/\//i.test(href)) {
      var url;
      try {
        url = new URL(href);
      } catch (error) {
        return null;
      }
      if (url.host !== host) return null;
      path = url.pathname + url.search + url.hash;
    }

    if (!PATH_RE.test(path)) return null;
    return root.replace(/\/$/, '') + path;
  }

  function install(win) {
    var doc = win.document;
    var root = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/';
    if (root === '/') return;

    var host = win.location.host;

    function localizeLink(a) {
      var next = localizeHref(a.getAttribute('href'), root, host);
      if (next) a.setAttribute('href', next);
    }

    function scan(scope) {
      Array.prototype.forEach.call(scope.querySelectorAll(LINK_SELECTOR), localizeLink);
    }

    // Safety net: fix the link at click time in case a render slipped past the observer.
    doc.addEventListener('click', function (event) {
      var a = event.target && event.target.closest && event.target.closest('a[href]');
      if (a) localizeLink(a);
    }, true);

    function init() {
      scan(doc);
      new win.MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (node.nodeType !== 1) return;
            if (node.tagName === 'A') localizeLink(node);
            else scan(node);
          });
        });
      }).observe(doc.body, { childList: true, subtree: true });
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  if (typeof window !== 'undefined') {
    try {
      install(window);
    } catch (error) {
      // Fail-safe: leave RPS links untouched if bootstrap fails.
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      localizeHref: localizeHref,
    };
  }
})();
